export const createStatsSlice = (set) => ({
  stats: {
    distance: 0,
    elevationGain: 0,
    elevationLoss: 0,
    pointCount: 0,
  },

  setStats: (newStats) =>
    set(
      (state) => ({
        stats: {
          ...state.stats,
          ...newStats,
        },
      }),
      undefined,
      "stats/setStats",
    ),

  updateStats: (partialStats) =>
    set(
      (state) => {
        const updatedStats = { ...state.stats };
        Object.entries(partialStats).forEach(([key, value]) => {
          if (value !== undefined && value !== null) {
            updatedStats[key] = value;
          }
        });
        return {
          stats: updatedStats,
        };
      },
      undefined,
      "stats/updateStats",
    ),
});
